import store from 'store'

// this object hold reference to the current count of notifications
const countContainer = { count: 0 }

const getUnreadNotificationCount = () => {
  const notifs = store.getState().notifications.list
  return notifs.reduce((count, e) => (e.read ? count : count + 1), 0)
}

export const listenAndAddNotificationsToTitle = () => {
  const originalTitle = document.title

  setInterval(() => {
    countContainer.count = getUnreadNotificationCount()
    if (countContainer.count === 0) {
      document.title = originalTitle
    } else {
      document.title = `(${countContainer.count}) ${originalTitle}`
    }
    if (process.env.REACT_APP_ELECTRON === 'true') {
      const { ipcRenderer } = window.require('electron')
      ipcRenderer.send('notifications-count-event', countContainer.count)
    }
  }, 2000)
}



// WEBPACK FOOTER //
// ./src/features/inTitleNotifications/index.js